module.exports = __webpack_public_path__ + "static/media/logo.edc3d392.svg";